/**
 * Gemeinsamer Ersatz für `IwmDropdownRechnungsart`, `IwmDropdownRechnungsartAufteilung`,
 * `IwmDropdownEntityTypes` und `IwmDropdownSpracheTypes` — alle vier unterscheiden sich im
 * Altclient nur in der Enum-Tabelle.
 */

import { useMemo } from 'react';

import { DropDownList } from '@/components/ui';
import { getEnumOptions, type EnumOption } from '@/utils/enumDisplay';

export interface EnumDropdownProps<T extends number> {
  value: T | null;
  onChange(value: T | null): void;
  displayNames: Record<T, string>;
  /** Feste Beschriftung über dem Feld (REQ-24 §2). */
  label?: string;
  readOnly?: boolean;
}

const FIELDS = { value: 'value', text: 'text' } as const;

export function EnumDropdown<T extends number>(props: EnumDropdownProps<T>) {
  const { displayNames } = props;
  const items = useMemo(() => getEnumOptions(displayNames), [displayNames]);

  return (
    <DropDownList<T, EnumOption<T>>
      value={props.value}
      onChange={(value) => {
        props.onChange(value);
      }}
      items={items}
      fields={FIELDS}
      label={props.label}
      readOnly={props.readOnly}
      showClearButton
    />
  );
}

export default EnumDropdown;
